'use client';

import { API_BASE_URL } from './config';

export function initTruecaller(requestNonce, onSuccess, onError) {
  const isAndroid = /Android/i.test(navigator.userAgent);
  
  if (!isAndroid) {
    onError('Truecaller is only supported on Android devices');
    return;
  }

  const appKey = process.env.NEXT_PUBLIC_TRUECALLER_APP_KEY;
  
  if (!appKey) {
    onError('Truecaller app key not configured');
    return;
  }

  const deepLink = `truecallersdk://truesdk/web_verify?` +
    `type=btmsheet` +
    `&requestNonce=${encodeURIComponent(requestNonce)}` +
    `&partnerKey=${encodeURIComponent(appKey)}` +
    `&partnerName=Numdle` +
    `&lang=en` +
    `&privacyUrl=${encodeURIComponent('https://theabbie.github.io/Numdle')}` +
    `&termsUrl=${encodeURIComponent('https://theabbie.github.io/Numdle')}` +
    `&loginPrefix=Login%20to` +
    `&loginSuffix=` +
    `&ctaPrefix=Verify` +
    `&ctaColor=%233b82f6` +
    `&ctaTextColor=%23ffffff` +
    `&btnShape=round` +
    `&skipOption=Use%20another%20method`;

  window.location.href = deepLink;

  setTimeout(() => {
    if (document.hasFocus()) {
      onError('Truecaller app not installed');
    } else {
      onSuccess();
    }
  }, 600);
}

export async function pollForSession(requestNonce, onSuccess, onError, maxAttempts = 30) {
  let attempts = 0;
  
  const poll = setInterval(async () => {
    attempts++;
    
    if (attempts > maxAttempts) {
      clearInterval(poll);
      onError('Session verification timeout');
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/verify-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId: requestNonce })
      });

      if (response.ok) {
        const data = await response.json();
        clearInterval(poll);
        onSuccess(data);
      }
    } catch (error) {
      console.error('Poll error:', error);
    }
  }, 2000);

  return () => clearInterval(poll);
}
